import {
  androidLanguages as sharedAndroidLanguages,
  type AndroidLanguage,
  getLanguageByCodeFrom,
  moveLanguageToFront,
  resolveToAndroidLocaleFrom,
} from '../../../api/src/shared/android-languages';

import { captureAndReportError } from '../utils/errorReporting';

const WEB_DEFAULT_LOCALE = 'en-US';

export type { AndroidLanguage };

export const androidLanguages = moveLanguageToFront(
  sharedAndroidLanguages,
  WEB_DEFAULT_LOCALE,
);

export const getLanguageByCode = (
  code: string,
): AndroidLanguage | undefined => {
  return getLanguageByCodeFrom(androidLanguages, code);
};

export function resolveToAndroidLocale(
  input: string,
  defaultLocale: string = WEB_DEFAULT_LOCALE,
): string | null {
  return resolveToAndroidLocaleFrom(
    androidLanguages,
    input,
    defaultLocale,
    (error) => {
      captureAndReportError('Error matching language code:', error);
    },
  );
}
